export default "<h1>Processing Error</h1>\r\n<h4>Error occurred while processing data</h4>\r\n<h5>{{display}}</h5>\r\n";